// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from PriceSummaryItem.module.scss  */
.PriceSummaryItem-module-Separator_5wQ {
  width: 100%;
  height: 1px;
  margin-top: 0;
  margin-bottom: 16px;
  border: 0;
  background: var(--price-summary-total-border); }

.PriceSummaryItem-module-Root_p5Z {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1.286;
  color: var(--price-summary-color); }
  .PriceSummaryItem-module-Root_p5Z + .PriceSummaryItem-module-Root_p5Z {
    margin-top: 12px; }
    .PriceSummaryItem-module-Root_p5Z + .PriceSummaryItem-module-Root_p5Z .PriceSummaryItem-module-Separator_5wQ {
      margin-top: 4px; }

.PriceSummaryItem-module-Name_rwv {
  display: flex;
  flex-shrink: 1;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  width: calc(100% - 100px);
  padding-right: 8px;
  color: inherit; }
  .PriceSummaryItem-module-Name_rwv img {
    margin-left: 8px; }

.PriceSummaryItem-module-Value_2jo {
  flex-shrink: 0;
  box-sizing: border-box;
  width: 100px;
  text-align: right;
  color: inherit; }

.PriceSummaryItem-module-hasAccent_2f8 {
  font-weight: 600;
  color: var(--price-summary-total-color); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/PriceSummaryItem/PriceSummaryItem.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6CAA6C,EAAE;;AAEjD;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC,EAAE;EACnC;IACE,gBAAgB,EAAE;IAClB;MACE,eAAe,EAAE;;AAEvB;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc,EAAE;EAChB;IACE,gBAAgB,EAAE;;AAEtB;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,uCAAuC,EAAE","sourcesContent":["/*  imported from PriceSummaryItem.module.scss  */\n.PriceSummaryItem-module-Separator_5wQ {\n  width: 100%;\n  height: 1px;\n  margin-top: 0;\n  margin-bottom: 16px;\n  border: 0;\n  background: var(--price-summary-total-border); }\n\n.PriceSummaryItem-module-Root_p5Z {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  font-size: 0.875rem;\n  font-weight: normal;\n  line-height: 1.286;\n  color: var(--price-summary-color); }\n  .PriceSummaryItem-module-Root_p5Z + .PriceSummaryItem-module-Root_p5Z {\n    margin-top: 12px; }\n    .PriceSummaryItem-module-Root_p5Z + .PriceSummaryItem-module-Root_p5Z .PriceSummaryItem-module-Separator_5wQ {\n      margin-top: 4px; }\n\n.PriceSummaryItem-module-Name_rwv {\n  display: flex;\n  flex-shrink: 1;\n  flex-wrap: wrap;\n  align-items: center;\n  box-sizing: border-box;\n  width: calc(100% - 100px);\n  padding-right: 8px;\n  color: inherit; }\n  .PriceSummaryItem-module-Name_rwv img {\n    margin-left: 8px; }\n\n.PriceSummaryItem-module-Value_2jo {\n  flex-shrink: 0;\n  box-sizing: border-box;\n  width: 100px;\n  text-align: right;\n  color: inherit; }\n\n.PriceSummaryItem-module-hasAccent_2f8 {\n  font-weight: 600;\n  color: var(--price-summary-total-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
